import { ToastDesignTokens } from '@primeuix/themes/aura/toast';

export const toastTokens: ToastDesignTokens = {
  root: {
    width: '25rem',
    borderRadius: '{content.border.radius}',
    borderWidth: '1px',
    transitionDuration: '{transition.duration}',
  },
  icon: {
    size: '1.125rem',
  },
  content: {
    padding: '{overlay.popover.padding}',
    gap: '0.5rem',
  },
  text: {
    gap: '0.5rem',
  },
  summary: {
    fontWeight: '500',
    fontSize: '1rem',
  },
  detail: {
    fontWeight: '500',
    fontSize: '0.875rem',
  },
  closeButton: {
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '{toast.close.button.width} / 2',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      offset: '{focus.ring.offset}',
    },
  },
  closeIcon: {
    size: '1rem',
  },
  css: () => `
    .p-toast-message-content:has(.p-toast-detail:empty) .p-toast-message-text {
      gap: 0;
    }
  `,
  colorScheme: {
    light: {
      root: {
        blur: '1.5px',
      },
      info: {
        background: '{primary.700}',
        borderColor: '{primary.800}',
        color: '#ffffff',
        detailColor: '#ffffff',
        shadow: '0 4px 8px 0 rgba(2, 5, 10, 0.04)',
        closeButton: {
          hoverBackground: '{primary.800}',
          focusRing: {
            color: '{primary.200}',
            shadow: 'none',
          },
        },
      },
      success: {
        background: '{green.700}',
        borderColor: '{green.800}',
        color: '#ffffff',
        detailColor: '#ffffff',
        shadow: '0 4px 8px 0 rgba(1, 9, 2, 0.04)',
        closeButton: {
          hoverBackground: '{green.800}',
          focusRing: {
            color: '{green.600}',
            shadow: 'none',
          },
        },
      },
      warn: {
        background: '{orange.700}',
        borderColor: '{orange.800}',
        color: '#ffffff',
        detailColor: '#ffffff',
        shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
        closeButton: {
          hoverBackground: '{orange.800}',
          focusRing: {
            color: '{orange.600}',
            shadow: 'none',
          },
        },
      },
      error: {
        background: '{red.700}',
        borderColor: '{red.800}',
        color: '#ffffff',
        detailColor: '#ffffff',
        shadow: '0 4px 8px 0 rgba(10, 3, 3, 0.04)',
        closeButton: {
          hoverBackground: '{red.800}',
          focusRing: {
            color: '{red.600}',
            shadow: 'none',
          },
        },
      },
      secondary: {
        background: '{surface.100}',
        borderColor: '{surface.200}',
        color: '{surface.600}',
        detailColor: '{surface.700}',
        shadow: '0 4px 8px 0 rgba(4, 5, 6, 0.04)',
        closeButton: {
          hoverBackground: '{surface.200}',
          focusRing: {
            color: '{surface.600}',
            shadow: 'none',
          },
        },
      },
      contrast: {
        background: '{surface.900}',
        borderColor: '{surface.950}',
        color: '{surface.50}',
        detailColor: '{surface.0}',
        shadow: '0 4px 8px 0 rgba(0, 0, 1, 0.04)',
        closeButton: {
          hoverBackground: '{surface.800}',
          focusRing: {
            color: '{surface.50}',
            shadow: 'none',
          },
        },
      },
    },
    dark: {
      root: {
        blur: '10px',
      },
      info: {
        background: '{violet.100}',
        borderColor: '{violet.50}',
        color: '{primary.950}',
        detailColor: '{primary.950}',
        shadow: '0 4px 8px 0 rgba(2, 5, 10, 0.04)',
        closeButton: {
          hoverBackground: '{violet.50}',
          focusRing: {
            color: '{violet.200}',
            shadow: 'none',
          },
        },
      },
      success: {
        background: '{green.200}',
        borderColor: '{green.100}',
        color: '{primary.950}',
        detailColor: '{primary.950}',
        shadow: '0 4px 8px 0 rgba(1, 9, 2, 0.04)',
        closeButton: {
          hoverBackground: '{green.100}',
          focusRing: {
            color: '{green.300}',
            shadow: 'none',
          },
        },
      },
      warn: {
        background: '{orange.200}',
        borderColor: '{orange.100}',
        color: '{primary.950}',
        detailColor: '{primary.950}',
        shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
        closeButton: {
          hoverBackground: '{orange.100}',
          focusRing: {
            color: '{orange.300}',
            shadow: 'none',
          },
        },
      },
      error: {
        background: '{red.200}',
        borderColor: '{red.100}',
        color: '{primary.950}',
        detailColor: '{primary.950}',
        shadow: '0 4px 8px 0 rgba(10, 3, 3, 0.04)',
        closeButton: {
          hoverBackground: '{red.100}',
          focusRing: {
            color: '{red.300}',
            shadow: 'none',
          },
        },
      },
      secondary: {
        background: '{surface.800}',
        borderColor: '{surface.700}',
        color: '{surface.300}',
        detailColor: '{surface.0}',
        shadow: '0 4px 8px 0 rgba(4, 5, 6, 0.04)',
        closeButton: {
          hoverBackground: '{surface.700}',
          focusRing: {
            color: '{surface.300}',
            shadow: 'none',
          },
        },
      },
      contrast: {
        background: '{surface.0}',
        borderColor: '{surface.100}',
        color: '{surface.950}',
        detailColor: '{surface.950}',
        shadow: '0 4px 8px 0 rgba(0, 0, 1, 0.04)',
        closeButton: {
          hoverBackground: '{surface.100}',
          focusRing: {
            color: '{surface.950}',
            shadow: 'none',
          },
        },
      },
    },
  },
};
